export default "__VITE_ASSET__DPba8gJb__"